var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-tab",class:{hover: _vm.isHover && !_vm.item.active, active: _vm.item.active},on:{"mouseover":_vm.mouseOver,"mouseout":_vm.mouseOver}},[_c('div',{staticClass:"text-container"},[_c('span',[_vm._v("\n      "+_vm._s(_vm.item.name)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78c0235c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/help-center/ProductTab.vue
// module id = null
// module chunks = 